import { connect } from "react-redux";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { UserDetailsViewModel } from "../../configuration/api/apiSchema";
import { AuthData } from "../../pages/Auth/reducer";
import { HandymanAppState } from "../../configuration/redux/reducers";
import { getUserDetails } from "../../pages/Auth/actions";
import { Snackbar, Alert } from "@mui/material";

interface PassedProps {
  children: React.ReactNode;
}

interface DispatchFromProps {
  getUserDetails: () => void;
}

interface StateFromProps {
  authData?: AuthData;
  userDetails?: UserDetailsViewModel;
}

type Props = PassedProps & DispatchFromProps & StateFromProps;

const OnboardingProvider: React.FC<Props> = (props) => {
  const { authData, children } = props;
  const [alertVisible, setAlertVisible] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (authData?.status === "pendingSelectCategories") {
      // Only show category selection for handymen, skip for customers
      if (authData?.role === "handyman") {
        // If we're *not* already on /select-categories, navigate there
        if (window.location.pathname !== "/select-categories") {
          navigate("/select-categories", { replace: true });
        }
        
        // Only show alert if not on select categories page
        if (window.location.pathname !== "/select-categories") {
          setAlertVisible(true);
        }
      } else {
        // For customers, skip category selection and go directly to profile
        navigate("/profile", { replace: true });
      }
    } else {
      // Hide alert if status is not pendingSelectCategories
      setAlertVisible(false);
    }
  }, [authData, navigate]);

  const handleClose = (event?: React.SyntheticEvent, reason?: string) => {
    if (reason === "clickaway") {
      return;
    }
    setAlertVisible(false);
  };

  return (
    <>
      {children}

      <Snackbar
        open={alertVisible}
        autoHideDuration={6000}
        onClose={handleClose as any}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClose} severity="info" sx={{ width: "100%" }}>
          Action required: Please select your categories to proceed.
        </Alert>
      </Snackbar>
    </>
  );
};

const mapStateToProps = (state: HandymanAppState): StateFromProps => ({
  authData: state.user.authData,
  userDetails: state.user.userDetails,
});

export default connect<
  StateFromProps,
  DispatchFromProps,
  PassedProps,
  HandymanAppState
>(mapStateToProps, {
  getUserDetails,
})(OnboardingProvider);
